import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const key = 'allOrganizations';

const rootSelector = (state) => {
  if (state && state[key]) {
    return state[key];
  }
  return initialState;
};

export const isOrganizationsInitializedSelector = createSelector(rootSelector, ({ initialized }) => initialized);
export const isOrganizationsErroredSelector = createSelector(rootSelector, ({ error }) => error);
export const organizationsListSelector = createSelector(rootSelector, ({ list }) => list);
